import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'za',
    alia: 'za',
    region: 'South Africa',
    regionText: 'South Africa',
    language: 'English',
    languageText: 'English',
    appId: 15,
    acceptLanguage: 'en-ZA,en;q=0.9',
};
export default theLocale;
